import { iorganizationManagementApiV1 as om } from '@deepup/internal-apis';
import type { Project } from '@projects/types';

export type ActivityStateFilterMode = 'all' | om.ActivityState;

export const formatProjectActivityStateLabel = (
  activityState: Project['activityState'],
): string => {
  if (activityState === undefined || activityState === null) {
    return '—';
  }
  switch (activityState) {
    case om.ActivityState.NOT_STARTED:
      return 'Not started';
    case om.ActivityState.PAUSED:
      return 'Paused';
    case om.ActivityState.ACTIVE:
      return 'Active';
    case om.ActivityState.FINISHED:
      return 'Finished';
    case om.ActivityState.CLOSED:
      return 'Closed';
    case om.ActivityState.UNKNOWN:
      return 'Unknown';
    default:
      return '—';
  }
};

export const filterProjectsByActivityState = (
  projects: Project[],
  mode: ActivityStateFilterMode,
): Project[] => {
  if (mode === 'all') {
    return projects;
  }
  return projects.filter((p) => p.activityState === mode);
};
